// eslint-disable-next-line no-undef
const stripe = new Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
export default stripe
